import { Grid, Typography } from "@mui/material";

export const NoSchedules = () => (
  <Grid flexDirection="column" alignItems="center" container mt="15%">
    <Typography variant="shy">There are no schedules yet.</Typography>
  </Grid>
);
